import React from 'react';
import { Dropdown } from '@ihsm/ui-shared';

export const LoadedDatePicker: React.FC = () => (
  <Dropdown
    labelText="Loaded"
    value="03-Sep-2021 7:50"
    options={[{ displayText: '03-Sep-2021 7:50', value: '03-Sep-2021 7:50' }]}
    onChange={() => {}}
    disabled
  />
);
